import React, {Fragment} from 'react';
import b_ from 'b_';

import {Survey, SurveySlug} from 'client/common/types';

import history from 'client/common/utils/history';
import {useCopySurvey} from 'client/common/hooks/survey';

import {Button} from 'client/common/components/lego';

import {getMenuItems, useModerationCancel} from './utils';

const b = b_.with('creative-settings-form');

function useFormProps(props: BottomButtonsProps) {
    const {slug, state, name} = props;

    const copySurvey = useCopySurvey(slug, name, {openAfterCopy: true});
    const cancelModeration = useModerationCancel(slug);

    const onCopySurvey = () => {
        void copySurvey({
            access: true,
            audience: true
        });

        history.push({pathname: '/creatives'});
    };

    const handleMenuChange = (value: string) => {
        if (value === 'copy') {
            onCopySurvey();
        }

        if (value === 'cancelModeration') {
            void cancelModeration();
        }
    };

    const bottomButtons = getMenuItems(state);

    return {bottomButtons, handleMenuChange};
}

interface BottomButtonsProps {
    slug: SurveySlug;
    state: Survey['state'];
    name: Survey['name'];
}

export default function BottomButtons(props: BottomButtonsProps) {
    const {bottomButtons, handleMenuChange} = useFormProps(props);

    return (
        <Fragment>
            {bottomButtons.map(item => (
                <Button
                    className={b('bottom-button')}
                    key={item.value}
                    onClick={() => handleMenuChange(item.value)}
                    size='l'
                    view='dl-default'
                    width='max'
                >
                    {item.content}
                </Button>
            ))}
        </Fragment>
    );
}
